module.exports = __webpack_public_path__ + "static/img/Logo_Aftech.bf81bac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/support/Logo_Aftech.png
// module id = YVB4
// module chunks = 36